export const HOSTNAME = {
    localhost: 'localhost',
    sit: 'adm2.sit.test.visma.net',
    int: 'adm2.aws.int.test.visma.net',
    stag: 'adm2.stag.visma.net',
    prod: 'adm2.visma.net'
}